import { useState, useEffect } from "react";

export function useCyclingIndex(items = [], interval = 5000, stop = false,) {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (items.length === 0 || stop) return;

        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % items.length);
        }, interval);

        return () => clearInterval(timer);
    }, [items.length, interval, stop]);

    return index;
}
